import Home from "./Home";
import Footer from "./components/footer"
import "./App.css"
import Steps from "./components/Steps";
import AboutUs from "./components/install";
import Products from "./components/Products";

function App() {

  return (
    <>
    <Home/>
    <AboutUs/>
    <Products/>
    <Steps/>
    <Footer/>


    



      {/*
      <Testimonial/>
      <Manage/>
       */}
    </>
  );
}

export default App;
